import Page404 from './views/page404';

export default [
    { path: '*', name: 'Page404', component: Page404 }
]